function initSubMenuManager() {
  if ($(window).outerWidth() >= smBreakpoint ) {
    $('#sub-menu').collapse('show');
  }
}
